import hexToRgba from "hex-rgba";
import commonTheme from "./common-theme";

const theme = {
  name: "bibino-dark",
  fonts: commonTheme.fonts,
  breakpoints: commonTheme.breakpoints,
  isDarkMode: true,
  colors: {
    ...commonTheme.colors,
    primary: "#9a7cf6",
    primaryLight: hexToRgba("#8f6df5", 18),
    primaryLight2: hexToRgba("#8f6df5", 32),
    primaryLighter: "#8966f2",
    primaryDarker: "#704dd9",
    primaryBackground: "#7c55f1",

    secondary: "#259287",
    secondaryLight: hexToRgba("#2aa598", 18),
    secondaryLight2: hexToRgba("#2aa598", 32),
    secondaryLighter: "#2aa598",
    secondaryDarker: "#21837a",

    get highEmphasis() {
      return this.white;
    },
    get mediumEmphasis() {
      return this.white70;
    },
    get lowEmphasis() {
      return this.white40;
    },
    get outline() {
      return this.white20;
    },
    get outlineHover() {
      return this.white40;
    },
    get surface() {
      return "#121212";
    },
    get surfaceElevated1() {
      return "#2e2e2e";
    },
    get surfaceElevated2() {
      return "#3e3e3e";
    },
    get surfaceElevated3() {
      return "#525252";
    },
    get hover() {
      return this.white8;
    },
    get iconBackground() {
      return this.white12;
    },
    get overlay() {
      return this.black54;
    },

    warningBase: "#ce4364",
    warningLight: hexToRgba("#dc6fd1", 12),
    warningLight2: hexToRgba("#dc6fd1", 32),
    warningLighter: "#d35674",
    warningDarker: "#b93c5a",

    tint2: "#d8972b",
    tint2Light: hexToRgba("#ffcc3f", 12),

    // for device tab marks
    tint3: "#0083c2",
    tint3Light: hexToRgba("#0083c2", 20),
    tint4: "#9e4bd9",
    tint4Light: hexToRgba("#9b1ff4", 24),
    "command-tint2": "#d77904",
    "command-tint2Light": hexToRgba("#f58900", 20),
    "command-tint4": "#019587",
    "command-tint4Light": hexToRgba("#00aa9a", 20),
    "command-tint8": "#c75d99",
    "command-tint8Light": hexToRgba("#c75d99", 20),

    tintRed: "#FF416F",
    tintOrange: "#F58900",
    tintYellow: "#FAB500",
    tintYellowLight: hexToRgba("FAB500", 12),
    tintOlive: "#92AD00",
    tintGreen: "#58A509",
    tintTurquoise: "#2AA598",
    tintTurquoiseLight: hexToRgba("2AA598", 12),
    tintBlue: "#4D8DF7",
    tintIndigo: "#4F5CFF",
    tintPurple: "#8F6DF5",
    tintPurpleLight: hexToRgba("8F6DF5", 12),
    tintPink: "#FA48AD",
    tintBrown: "#825F5F"
  }
};

export default theme;
